<navigation-dropdown
  [isNavigationDropdownButtonClassNeeded]="!withoutBorderOnFocus"
  [menuItems]="helpMenuItems"
  [dropdownTitle]="'support_center' | localize"
  [dropdownMenuClass]="!showNextStyles ? 'ml-8px' : null">
  <i class="icon" [class.navigation-dropdown-icon-v2]="withoutBorderOnFocus" [uiType]="iconType" ui-icon gh-dropdown-toggle></i>
</navigation-dropdown>
